<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-07 18:16:03
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-09-09 10:53:03
-->
<template>
	<div>
		<span class="yx-color-text-primary">{{ row['remark'] || '-' }}</span>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	name: 'remarkCell',
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {},
	props: {},
	components: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped></style>
